module.exports = __webpack_public_path__ + "img/18068.2cf29eb5.png";